import * as Yup from 'yup';
import { AccountAddress } from '../../../../shared/types/modules/account';
import { validationSchema as crmAddressValidationSchema } from '../../modules/accounts/form/address/formData';
import { ORBIT_ADDRESS_QUADRANT_OPTIONS } from './quadrantOptions';
import {
    isOrbitAddressStructurallyComplete,
    ORBIT_ADDRESS_INCOMPLETE_MESSAGE,
} from './addressCompleteness';

const quadrantValues = [
    '',
    ...ORBIT_ADDRESS_QUADRANT_OPTIONS.map((q) => String(q.id)),
];

export const getOrbitAddressValidationSchema = (
    getType1Values: () => string[] = () => []
) =>
    crmAddressValidationSchema.shape({
        type1: Yup.string()
            .required('El tipo 1 es obligatorio')
            .test('orbit-type1-valid', 'El tipo 1 no es válido', (value) => {
                if (!value) return false;
                const allowed = getType1Values();
                if (allowed.length === 0) return true;
                return allowed.includes(String(value));
            }),
        quadrant1: Yup.string().oneOf(quadrantValues),
        quadrant2: Yup.string().oneOf(quadrantValues),
        quadrant3: Yup.string().oneOf(quadrantValues),
        address: Yup.string().test(
            'orbit-address-complete',
            ORBIT_ADDRESS_INCOMPLETE_MESSAGE,
            function () {
                return isOrbitAddressStructurallyComplete(
                    this.parent as AccountAddress
                );
            }
        ),
    });
